import InventoryListingSideBar from './InventoryListingSideBar';
export default InventoryListingSideBar;